class Contact {
  constructor () {
    this.validationForm();
  }

  validationForm () {
    $(window).on('load',function(){
      $(".contact-form").validationEngine({
        promptPosition: 'topLeft',
        scroll: false
      });
    });
  }
}

export default Contact;
